import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Box, Link } from '@mui/material';
import React from 'react';

import { useTheme } from '@dh/hooks';
import { Column } from '@dh/styles';

import { ContactCardBodyMedium, ContactCardItemContainer } from './styles';

type Props = {
    address: string;
    addressPrefix?: string;
    addressPostfix?: string;
    multiline?: boolean;
};

const urlForAddress = (address: string) =>
    `https://www.openstreetmap.org/search?query=${encodeURIComponent(address)}`;

export const ContactCardAddressItem = ({
    address,
    addressPrefix,
    addressPostfix,
    multiline
}: Props) => {
    const { spacing } = useTheme();
    return (
        <ContactCardItemContainer>
            <LocationOnIcon sx={{ alignSelf: 'start' }} />
            <Column>
                {addressPrefix && <ContactCardBodyMedium>{addressPrefix}</ContactCardBodyMedium>}
                <Link
                    href={urlForAddress(address)}
                    target='_blank'
                    rel='noopener noreferrer'
                    data-testid='address-link'
                >
                    {multiline ? (
                        address
                            .split(',')
                            .map((s, index) => (
                                <ContactCardBodyMedium key={index}>
                                    {s.trim()}
                                </ContactCardBodyMedium>
                            ))
                    ) : (
                        <ContactCardBodyMedium>{address}</ContactCardBodyMedium>
                    )}
                </Link>
                {addressPostfix && (
                    <>
                        <Box sx={{ height: spacing(2) }} />
                        <ContactCardBodyMedium>{addressPostfix}</ContactCardBodyMedium>
                    </>
                )}
            </Column>
        </ContactCardItemContainer>
    );
};
